import { FilterInstance, FilterKind } from '../types';

function filterInFrontend<ColKeys extends string, Row extends Record<string, any>>(
  filter: FilterInstance<ColKeys>,
  row: Row
): boolean {
  //TODO
  throw new Error('Regex filter not implemented');
}

export const regexFilter: FilterKind = {
  filterInFrontend,
};
